import React, { Fragment } from "react";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { CTM_IMPORT_COLUMNS } from "../../../utils/constants/CategoryTrackMapping";
import StatusChip from "../../common/StatusChip";

const MONO_KEYS = ["meta_ad_account_id", "meta_campaign_id"];

/** One previewed upload row, tinted by its check, with the reason on a line under a failing row. */
const CtmImportRow = ({ row, index, result, isChecking }) => {
  const tone = !result
    ? "bg-white"
    : result.ok
      ? "bg-emerald-50"
      : "bg-rose-50";

  const handleCellValue = ({ key }) => {
    if (key === "campaign_name" && result?.ok && result.campaign_name)
      return result.campaign_name;
    return row[key] || "—";
  };

  return (
    <Fragment>
      <tr className={`border-t border-gray-100 ${tone}`}>
        <td className={`sticky left-0 z-[1] px-2 py-1.5 ${tone}`}>
          <span className="flex items-center gap-1.5">
            {!result && isChecking && (
              <Loader2 className="h-4 w-4 animate-spin text-gray-400" />
            )}
            {result?.ok && (
              <CheckCircle2 className="h-4 w-4 text-emerald-600" />
            )}
            {result && !result.ok && (
              <XCircle className="h-4 w-4 text-rose-600" />
            )}
            <span className="text-gray-400">{index + 1}</span>
          </span>
        </td>
        {CTM_IMPORT_COLUMNS.map((c) => (
          <td
            key={c.key}
            className={`whitespace-nowrap px-2 py-1.5 text-gray-700 ${MONO_KEYS.includes(c.key) ? "font-mono text-[11px]" : ""}`}
          >
            {c.key === "track" ? (
              <span className="flex items-center gap-2">
                {handleCellValue({ key: c.key })}
                {result?.track_status && (
                  <StatusChip subtle status={`track_${result.track_status}`} />
                )}
              </span>
            ) : (
              handleCellValue({ key: c.key })
            )}
          </td>
        ))}
      </tr>
      {result && !result.ok && (
        <tr className="bg-rose-50">
          <td colSpan={CTM_IMPORT_COLUMNS.length + 1} className="px-2 pb-2">
            <span className="sticky left-9 inline-block pl-7 font-medium text-rose-700">
              {result.error}
            </span>
          </td>
        </tr>
      )}
    </Fragment>
  );
};

export default CtmImportRow;
